import { render, staticRenderFns } from "./CompanyModuleComponent.vue?vue&type=template&id=37bfeb0c&scoped=true"
import script from "./CompanyModuleComponent.vue?vue&type=script&lang=js"
export * from "./CompanyModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./CompanyModuleComponent.vue?vue&type=style&index=0&id=37bfeb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bfeb0c",
  null
  
)

export default component.exports